
import * as mq from './mq';
import screen from './screen';
import setViewport from './setViewport';

import 'waypoints/lib/noframework.waypoints';
import 'jquery.easing';
import 'velocity-animate';
import './jquery-plugin/fixedPageTop';
import './jquery-plugin/scrollFade';
import './jquery-plugin/splash';
import './jquery-plugin/pageHeader';
import './jquery-plugin/pageHero';
import './jquery-plugin/voiceSliderGroup';
import './jquery-plugin/scrollDocument';


setViewport();

$(function() {

  const $splash = $('.js-splash');
  const $scrollFade = $('.js-scrollShow');
  const $pageTop = $('.js-pageTop');
  const $pageHeader = $('.js-pageHeader');
  const $pageHero = $('.js-pageHero');
  const $voiceSliderGroup = $('.js-voice');
  const $scrollAnchor = $('a[href^="#"]').not('.no-smooth-scroll')

  function handleEnterNarrowViewport(mql) {
    if(!mql.matches) {
      return;
    }

    $scrollFade.scrollFade('destroy');
  }

  function handleEnterWideViewport(mql) {
    if(!mql.matches) {
      return;
    }

    $scrollFade.scrollFade({
      offset: 400
    });
  }

  $splash.splash().on('complete', function() {
    $pageHeader.pageHeader('show');
    screen.requestScrollEnabled('splash');
    $pageHero.pageHero().pageHero('showTagline');
  });


  $pageHeader.pageHeader();
  $pageTop.fixedPageTop();
  $voiceSliderGroup.voiceSliderGroup();
  $scrollAnchor.scrollDocument();

  if(mq.matchesNarrow()) {
    handleEnterNarrowViewport(mq.narrow);
  }
  else if(mq.matchesWide()) {
    handleEnterWideViewport(mq.wide);
  }

  screen.requestScrollDisabled('splash', false);

  mq.narrow.addListener(handleEnterNarrowViewport);
  mq.wide.addListener(handleEnterWideViewport)
});



// WEBPACK FOOTER //
// ./src/js/entry.js